import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Box, IconButton, Menu, MenuItem } from '@frontierag/frontier-ui-library';
import { Assignment as AssignmentIcon } from '@frontierag/frontier-ui-library/icons';
import useHeaderMenu from 'hooks/useHeaderMenu';

import styles from './styles';

const HeaderMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { t } = useTranslation('HeaderMenu');
  const open = Boolean(anchorEl);
  const { menuItems } = useHeaderMenu();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box sx={styles.menuTriggerContainer} data-testid="header-menu">
        <IconButton
          onClick={handleClick}
          size="medium"
          sx={styles.iconButton}
          aria-controls={open ? 'offline-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <AssignmentIcon sx={styles.menuTriggerButton} />
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="offline-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 2,
          sx: styles.menuPaper,
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {menuItems.map((item, idx) => {
          if (item.shouldHideMenuItem) return null;

          return (
            <MenuItem
              key={`offline-menu-item-${idx}`}
              sx={styles.menuItem}
              component={Link}
              to={item.url}
            >
              <Box role="span" sx={styles.menuItemIcon}>
                {item.icon}
              </Box>
              {t(item.label)}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default HeaderMenu;
